import { useDispatch, useSelector } from "react-redux";

import useAPI from "hooks/useAPI";
import { clearCorporateSessionAndNotify } from "lib/corporateModeSession";
import { logout, setTempSessionId, setUser } from "redux/slices/auth";
import shortid from "shortid";
import { useHistory } from "react-router-dom";
import useSelection from "hooks/useSelection";

const useAccount = () => {
  const dispatch = useDispatch();
  const { API } = useAPI({});
  const history = useHistory();
  const { clearBooking } = useSelection({});

  return {
    userIsLoggedIn: (user) => {
      console.log("testing user", user);
      if (user?._id) {
        return true;
      } else {
        return false;
      }
    },
    userHasMandatoryDetails: (user) => {
      //Check if we're missing any mandatory details
      const mandatoryDetails = ["name", "mobileNumber", "dob"];
      const missingMandatoryDetails = mandatoryDetails.filter(
        (detail) => !user[detail] || user[detail] === ""
      );
      return missingMandatoryDetails.length === 0;
    },
    getAndSetUser: async () => {
      console.log("useAccount -> getAndSetUser");
      try {
        const data = await API.get(`/user`);
        console.log("Setting user", data.user);
        dispatch(setUser({ user: data.user }));
        return data.user;
      } catch (error) {
        console.log("error: ", error);
        // If 401/403, user is not authenticated
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          dispatch(logout({}));
        }
      }
    },
    logout: async () => {
      try {
        await API.get(`/user/logout`);
      } catch (error) {
        console.log("error: ", error);
      } finally {
        // Clear token and user from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        dispatch(logout({}));
        clearBooking();
        clearCorporateSessionAndNotify();
        history.push("/");
      }
    },
  };
};

export default useAccount;
